import React, { Component } from 'react';
import "./FAQList.css";

export class QuestionAnwser extends Component {

  constructor(props) {

    super(props);
    this.state = {
      qa: null,
      isToggle: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillMount() {
    const QA = { ...this.props.qa };
    QA.answer = QA.answer.replaceAll("â\x80\x9D", "\"")
        .replaceAll("â\x80\x9C", "\"")
        .replaceAll("â\x80\x93", "-");
    if(this.isHtmlCode(QA.answer)){
      QA.answer = this.filterHtmlCode(QA.answer);
      QA.isLoop = true;
    }

    this.setState({ qa: QA });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.isParentOpen === false && this.state.isToggle){
      this.setState({ isToggle: false });
    }
  }

  handleClick(e) {
    this.setState({ isToggle: !this.state.isToggle });
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  }

  isHtmlCode = (content) => {
    return /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(content);
  };

  filterHtmlCode = (content) => {
    return content.replace(/(<([^>]+)>)/ig, '@!').split("@!").filter(c => c.trim().length !== 0);
  }

  render() {
    const qa = this.state.qa;
    const answerId = `answer-${qa.question.replace(/\s+/g, '-').toLowerCase().substring(0, 50)}`;

    let ASNTEMPLARTE = (
        <p id={answerId} className="list-group-item-text" style={{ display: this.state.isToggle ? 'block' : 'none' }}>
          {qa.answer}
        </p>
    );

    let headingOfAnswers = "";
    if(qa.isLoop){
      headingOfAnswers = qa.answer[0];
      const template = qa.answer.map((c, i) => {
        return (i === 0 && c.lastIndexOf(":") !== -1
                ? <li className="answer-title" key={`title-${i}`}><b>{c}</b></li>
                : <li key={`LIST-${i}`}>{c}</li>
        );
      });
      ASNTEMPLARTE = (
          <ol id={answerId} className="list-group-item-text none-style-list spacer-li" style={{ display: this.state.isToggle ? 'block' : 'none' }}>
            {template}
          </ol>
      );
    }

    return (
        <li className="list-group-item">
          <h4>
          <button
              type="button"
              className="faq-question-button card-title standard-blue"
              data-track="faq-links"
              aria-expanded={this.state.isToggle}
              aria-controls={answerId}
              onClick={this.handleClick}
              onKeyDown={this.handleKeyDown}
          >
            {qa.question}
          </button>
          </h4>
          {ASNTEMPLARTE}
        </li>
    );
  }
}